/**
 * Role-aware post-login redirect helpers.
 * super_admin → /superadmin
 * admin       → /admin (routed to /admin/courses via nested index redirect)
 * everyone else → /dashboard
 */
export function roleHome(user) {
  if (!user) return "/dashboard";
  if (user.role === "super_admin") return "/superadmin";
  if (user.role === "admin") return "/admin";
  return "/dashboard";
}

/**
 * Return true when the given user is allowed to visit `path`.
 * Used to decide whether to honor `?next=` or fall back to role home.
 */
export function canVisit(user, path) {
  if (!user || !path) return false;
  if (path.startsWith("/superadmin")) return user.role === "super_admin";
  if (path.startsWith("/admin")) return user.role === "admin" || user.role === "super_admin";
  // Public + student pages: everyone with a session can visit
  return true;
}

/**
 * Given a URLSearchParams `next` query and the freshly-logged-in user,
 * return the safest redirect target: `next` if the user has permission,
 * otherwise the role home.
 */
export function resolvePostLoginDest(nextParam, user) {
  if (nextParam && canVisit(user, nextParam)) return nextParam;
  return roleHome(user);
}
